import * as React from 'react';
import Contact from '../../models/contact';
import EmailInfo from '../../components/member/email-info';
import PhoneNumberInfo from '../../components/member/phone-number-info';

export interface Props {
  contact: Contact;
}

const ContactInfo: React.FunctionComponent<Props> = ({ contact }) => (
  <address>
    <p className="u-textSemiBold u-spaceBottomSm">
      {contact.firstName} {contact.lastName}
      {contact?.label && <span className="u-spaceLeftXs">({contact.label})</span>}
    </p>
    {contact?.emailAddresses?.map((emailAddress) => (
      <EmailInfo key={`email-${emailAddress.id}`} emailAddress={emailAddress} />
    ))}
    {contact?.phoneNumbers?.map((phoneNumber) => (
      <PhoneNumberInfo key={`phone-number-${phoneNumber.id}`} phoneNumber={phoneNumber} />
    ))}
  </address>
);

export default ContactInfo;
